import React, { FC } from 'react';
import { Card } from 'antd';
import { renderCurrency } from '../../utils/DataAccessUtils';
import PartsWithQuantityRowDisplay from '../supplier_work_orders_detail_charges_page/PartsWithQuantityRowDisplay';
import EquipmentInServiceCallRowDisplay from '../supplier_work_orders_detail_charges_page/EquipmentInServiceCallRowDisplay';

const WorkOrderPartsPrintSection: FC<any> = ({
	workOrder,
	parts,
	equipment,
	totalPartsCost,
	showCost,
	currentUser,
}): React.ReactElement => (
	<>
		{parts.length > 0 ? (
			<div className="mt-4">
				<Card
					title="Parts"
					extra={
						showCost ? (
							<div>{`Total Cost: ${renderCurrency(currentUser)(totalPartsCost)}`}</div>
						) : null
					}
				>
					<table className="w-full text-left">
						<thead>
							<tr className="border-0 border-b border-solid border-gray-300">
								<th className="bodymedium py-2">Part</th>
								<th className="bodymedium w-24 py-2">Quantity</th>
								{showCost ? <th className="bodymedium w-32 py-2">Cost</th> : null}
							</tr>
						</thead>
						<tbody>
							{parts.map((workOrderPart) => (
								<tr
									key={workOrderPart.id}
									className="border-0 border-b border-solid border-gray-200"
								>
									<td className="py-2 align-top">
										<PartsWithQuantityRowDisplay
											workOrderPart={workOrderPart}
											workOrder={workOrder}
											isPrintView
										/>
									</td>
									<td className="bodyregular py-2 align-top">
										{workOrderPart.partsQuantity ? (
											workOrderPart.partsQuantity
										) : (
											<div className="flex flex-row items-center">
												<div>0</div>
												<div className="ml-1 text-gray-400">{`(Returned)`}</div>
											</div>
										)}
									</td>
									{showCost ? (
										<td className="bodyregular whitespace-nowrap py-2 align-top">
											{renderCurrency(currentUser)(workOrderPart.totalPartsCost)}
										</td>
									) : null}
								</tr>
							))}
						</tbody>
					</table>
				</Card>
			</div>
		) : null}
		{equipment.length > 0 ? (
			<div className="mt-4">
				<Card title="Equipment">
					{equipment.map((equipmentLine) => (
						<EquipmentInServiceCallRowDisplay
							key={equipmentLine.id}
							equipmentInWorkOrder={equipmentLine}
							isPrintView
						/>
					))}
				</Card>
			</div>
		) : null}
	</>
);

export default WorkOrderPartsPrintSection;
